import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import { Logo } from "../../components/Logo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/app/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-alto-black text-white">
      <div className="hidden lg:flex flex-col justify-between p-12 marketing-grid-bg border-r border-white/10">
        <Link to="/"><Logo dark size={34} /></Link>
        <div>
          <h1 className="font-display text-4xl font-extrabold leading-tight">Capture.<br />Follow up.<br /><span className="text-alto-red">Grow.</span></h1>
          <p className="text-neutral-400 mt-5 max-w-sm text-sm">Sign in to your AllToMAIDIt workspace.</p>
        </div>
        <p className="text-xs text-neutral-600">© {new Date().getFullYear()} AllToMAIDIt Solutions</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8"><Link to="/"><Logo dark size={32} /></Link></div>
          <h2 className="font-display text-3xl font-bold">Sign in</h2>
          <p className="text-neutral-400 text-sm mt-2">Welcome back to your workspace.</p>
          <form onSubmit={submit} className="space-y-4 mt-8" data-testid="login-form">
            <div>
              <label className="block text-xs font-semibold text-neutral-400 mb-1.5">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required className="w-full bg-alto-charcoal border border-white/15 rounded-md px-4 py-3 text-sm focus:border-alto-red outline-none" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-neutral-400 mb-1.5">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required className="w-full bg-alto-charcoal border border-white/15 rounded-md px-4 py-3 text-sm focus:border-alto-red outline-none" />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit" className="btn-red w-full font-bold px-6 py-3.5 rounded-md inline-flex items-center justify-center gap-2 text-sm disabled:opacity-60">
              {loading ? "Signing in…" : <>SIGN IN <ArrowRight size={16} /></>}
            </button>
          </form>
          <p className="text-sm text-neutral-400 mt-6">No account? <Link to="/app/register" data-testid="to-register" className="text-alto-red font-semibold">Start your trial</Link></p>
          <Link to="/" className="text-xs text-neutral-600 mt-8 inline-block hover:text-neutral-400">← Back to website</Link>
        </div>
      </div>
    </div>
  );
}
